import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	GetSeasonQueryType,
	SeasonCreationType,
	SeasonDeletionType,
	SeasonModificationType,
	SeasonUpdatePathType,
} from '@schemas'

export const getSeason = async ({
	body = {},
	query = {
		year: '',
	} as GetSeasonQueryType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const createSeason = async ({
	body = {
		title: '',
		startDate: '',
		endDate: '',
		activeYn: 0,
		targetUsd: 0,
		targetQuantity: 0,
	} as SeasonCreationType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteSeason = async ({
	params = { seasonId: '' } as SeasonDeletionType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season/${params.seasonId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateSeason = async ({
	params = { seasonId: '' } as SeasonUpdatePathType,
	body = {
		title: '',
		startDate: '',
		endDate: '',
		activeYn: 0,
		targetUsd: 0,
		targetQuantity: 0,
	} as SeasonModificationType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season/${params.seasonId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const seasonApi = {
	getSeason: getSeason,
	createSeason: createSeason,
	deleteSeason: deleteSeason,
	updateSeason: updateSeason,
}

export default seasonApi
